import styles from "../../../LoanRequestPage.module.scss";
import { AttachmentIcon, DownloadIcon } from "../../../../../../assets/icons";
import { OrderType } from "../../../../../../model/orders/orders";
import { CreditInfo, EmployeeData } from "../../../../../../model/credit-info/credit-info";

type Props = {
	orderDetails: CreditInfo | undefined;
};

const IdentityTab = ({ orderDetails }: Props) => {
	const isIndividual = !!orderDetails?.employeeData;
	const isBusiness = !!orderDetails?.businessOwnerData;
	
	// Computed values based on user type
	const userInfo = {
		fullName: isIndividual 
			? orderDetails?.employeeData?.fullName 
			: orderDetails?.businessOwnerData?.contactInformation?.name,
		phoneNumber: isIndividual 
			? orderDetails?.employeeData?.mobileNumber 
			: orderDetails?.businessOwnerData?.contactInformation?.phoneNumber,
		idCardName: isIndividual 
			? orderDetails?.employeeData?.identityData?.idType 
			: "N/A",
		documentUrl: isBusiness 
			? orderDetails?.businessOwnerData?.document?.urlToFile 
			: undefined,
		address: isIndividual 
			? orderDetails?.employeeData?.address 
			: orderDetails?.businessOwnerData?.companyAddress,
		idNumber: isIndividual
		    ? orderDetails?.employeeData.identityData?.idNumber
			: "N/A"
	};

	const handleDownload = async (url: string) => {
		try {
			const response = await fetch(url);
			const blob = await response.blob();
			const blobUrl = URL.createObjectURL(blob);

			const link = document.createElement("a");
			link.href = blobUrl;
			link.download = "image_name";
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			window.open(url, "_blank");
		}
	};

	return (
		<section className={styles.detailsTabWrapper}>
			<div className={styles.detailsContent}>
				<div className={styles.item}>
					<div className={styles.label}>Name Submitted</div>
					<div className={styles.value}>
						{userInfo.fullName}
						
					</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Phone number</div>
					<div className={styles.value}>
						{userInfo.phoneNumber}
					</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>ID Card Number </div>
					<div className={styles.value}>
						{userInfo.idNumber}
					</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>ID Card Type </div>
					<div className={styles.value}>
						{userInfo.idCardName}
					</div>
				</div>
				{/* <div className={styles.item}>
					<div className={styles.label}>BVN Name</div>
					<div className={styles.value}>
						{!(customer?.bvnVerifyDetails?.firstName && customer?.bvnVerifyDetails?.lastName && customer?.bvnVerifyDetails?.middleName) ? (
							"/"
						) : (
							<>
								{customer?.bvnVerifyDetails?.firstName} {customer?.bvnVerifyDetails?.middleName} {customer?.bvnVerifyDetails?.lastName}
							</>
						)}
					</div>
				</div> */}
				
				{/* <div className={styles.item}>
					<div className={styles.label}>Uploaded Image</div>
					<div className={styles.value}>
						{customer?.photoUrl ? (
							<div
								className={styles.attachment}
								onClick={() => {
									window.open(customer.photoUrl, "_blank");
								}}
							>
								<AttachmentIcon /> View attachment
							</div>
						) : (
							"/"
						)}
					</div>
				</div> */}
				{/* <div className={styles.item}>
					<div className={styles.label}>Mobile Number</div>
					<div className={styles.value}>{customer.phoneNumber}</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Email Address</div>
					<div className={styles.value}>{customer.email} </div>
				</div> */}
			</div>
			{/* <div className={styles.imageWrapper}>
				<h3>NIN/ INTERNATIONAL PASSPORT IMAGE</h3>
				{imgUrl ? (
					<div className={styles.image}>
						<div className={styles.download} onClick={() => handleDownload(imgUrl)}>
							<DownloadIcon />
						</div>
						<img src={imgUrl} alt="identity" />
					</div>
				) : (
					<div className={styles.imagePlaceHolder}>No image uploaded</div>
				)}
			</div> */}
		</section>
	);
};

export default IdentityTab;
